import axios from "axios";
import axiosRetry from "axios-retry";
import { localStorageGetItem } from "../App";

export const getAccessTokenFromStorage = () =>
  new Promise(async (resolve, reject) => {
    try {
      const value = localStorageGetItem("userToken");
      resolve(value);
    } catch (error) {
      console.warn(error);
    }
  });
export const setHeaders = async (headers = null) => {
  let headerData;
  return getAccessTokenFromStorage().then((token) => {
    headerData = {
      "Content-type": "application/json",

      Accept: "application/json",
      ...(token && {
        // Authorization: `Bearer ${token}`,
        "X-Auth-Token": token,
      }),
    };

    if (headers) {
      headerData = { ...headerData, ...headers };
    }

    return headerData;
  });
};

const createAxios = async () => {
  let headers = await setHeaders(); // This function should handle any async operations needed for setting headers.
  const axiosInstance = axios.create({
    baseURL: "https://production-api.virtuesshop.co",
    headers: headers,
  });
  axiosRetry(axiosInstance, {
    retries: 1, // Reduce retry attempts
    retryCondition: (error) => {
      // Only retry for certain network or idempotent errors
      return (
        axiosRetry.isNetworkOrIdempotentRequestError(error) ||
        error.code === "ECONNABORTED" ||
        error.message.includes("Network Error") ||
        (error.response && [502, 503, 504].includes(error.response.status))
      );
    },
    retryDelay: (retryCount) => {
      return retryCount * 1000;
    },
  });

  return axiosInstance;
};

export default createAxios;
